export default __webpack_public_path__ + "static/media/indicator-incomplete.633a714f.svg";